import { useNavigate } from "react-router-dom";

export const useNavigateDetail = () => {
  const navigate = useNavigate();

  const navigateToClientDocument = (caseId) => {
    navigate(`/client-detail/${caseId}/documents`, {
      state: { from: "document-search" },
    });
  };

  return navigateToClientDocument;
};
